// extracted by mini-css-extract-plugin
export var activeLink = "navbar-links-module--active-link--LDFY-";
export var languagePicker = "navbar-links-module--language-picker--1DT+C";
export var link = "navbar-links-module--link--V5l1u";
export var submit = "navbar-links-module--submit--HY1FL";